import * as React from 'react'
import { api } from '../lib/api'
import Card from '@mui/joy/Card'
import Button from '@mui/joy/Button'
import Chip from '@mui/joy/Chip'
export default function Applicants({ jobId }: { jobId: string }) {
  const [rows, setRows] = React.useState<any[]>([])
  const [q, setQ] = React.useState('')
  const load = async () => {
    setRows(await api(`/jobs/${jobId}/applications`))
  }
  React.useEffect(() => {
    load()
  }, [jobId])
  const filtered = rows.filter(
    (r) => !q || (r.candidateName || '').toLowerCase().includes(q.toLowerCase())
  )
  return (
    <div className="max-w-6xl mx-auto p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-semibold">Applicants</h2>
        <input
          className="border rounded px-3 py-2"
          placeholder="Search…"
          value={q}
          onChange={(e) => setQ((e.target as any).value)}
        />
      </div>
      <div className="grid gap-3">
        {filtered.map((app) => (
          <Card key={app.id} variant="outlined" className="flex items-center justify-between">
            <div>
              <div className="font-semibold">{app.candidateName}</div>
              <div className="text-sm opacity-70">{app.headline}</div>
              <Chip size="sm" variant="soft" className="mt-2">
                {app.status}
              </Chip>
            </div>
            <div className="flex gap-2">
              <Button onClick={() => location.assign('/applications/' + app.id)}>Open</Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  )
}
